import { render } from "./DetailsResultats.vue?vue&type=template&id=00bf872c&scoped=true"
import script from "./DetailsResultats.vue?vue&type=script&lang=js"
export * from "./DetailsResultats.vue?vue&type=script&lang=js"

import "./DetailsResultats.vue?vue&type=style&index=0&id=00bf872c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bf872c"]])

export default __exports__